import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { NodeViewContent, type ReactNodeViewProps } from '@tiptap/react';

export function ZyCitationNodeView({ decorations }: ReactNodeViewProps) {
    return (
        <ZyNodeViewWrapper decorations={decorations}>
            <div className={`rounded-md bg-gray-50 px-4 py-2 italic text-gray-700 dark:bg-gray-900/20 dark:text-gray-300`}>
                <NodeViewContent />
            </div>
        </ZyNodeViewWrapper>
    );
}
